import GrayTextLink from './grayTextLink';

export default GrayTextLink;
